import { Injectable, inject } from '@angular/core';
import { AppStore } from 'src/app/store/app.store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
// import { Intercom } from 'ng-intercom';
import { SocketsService } from '../shared/socket.service';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MainService } from '../main/main.service';
import { GlobalFilterService } from '../shared/global-filter.service';
import { STORAGE_KEYS } from 'src/app/core/constants/storage.constants';
import { PrepaidCardService } from 'src/app/shared/prepaid-card-modal/prepaid-card.service';
import { getUserProfile, getUserProfiles, setUserProfiles, setDoctorSettings, setStoredRoleId } from 'src/app/core/session';
declare var Intercom: any;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  headers: any = new HttpHeaders({ 'Content-Type': 'application/json' });
  private readonly store = inject(AppStore);
  public userProfileData$ = this.store.subject('userProfile');
  public plan_info$ = this.store.subject('planInfo');
  public subscription_billing_page$ = this.store.subject('subscriptionBilling');
  private authPlanInfo: any;
  public getProfileData;
  public getProfileData$ = this.store.subject('profileResponse');
  public roleId$ = this.store.subject('roleId');
  public doctorDefaultVales$ = this.store.subject('doctorDefaults');
  is_allowed: any;
  public subscription_data: any
  public maintenanceData = this.store.subject('maintenance');
  unread_count: BehaviorSubject<any> = new BehaviorSubject(0);
  public showIntercomIcon: boolean = false
  public role_id;
  showNextKYB = 0;
  public showPersona = this.store.subject('showPersona');
  /** Delivered-terminal count for the session. Seeded from localStorage so a page refresh renders the
   *  terminal-gated cards immediately, then refreshed from every access_token_login response. */
  public total_terminals$ = this.store.subject('totalTerminals');

  private isDialogOpen = false;
  constructor(
    public http: HttpClient,
    public _socket: SocketsService,
    // public intercom: Intercom,
    public dialog: MatDialog,
    public router: Router,
    private _activated: ActivatedRoute,
    private globalService: GlobalFilterService
  ) {
    // Seeded from localStorage so a page refresh renders terminal-gated cards immediately.
    this.total_terminals$.next(+(localStorage.getItem(STORAGE_KEYS.TOTAL_TERMINALS) || 0));
  }

  public isAuthenticated() {
    if (!localStorage.getItem('token') || localStorage.getItem('token') == null) {
      return false;
    } else {
      return true;
    }
  }

  private readonly POST_LOGIN_RETURN_URL_KEY = 'postLoginReturnUrl';

  private isValidReturnUrl(url: string): boolean {
    return url && typeof url === 'string' && url.startsWith('/app/') && !url.startsWith('//');
  }

  private getCurrentAppUrl(): string | null {
    if (this.router.url && this.isValidReturnUrl(this.router.url)) {
      return this.router.url;
    }
    const path = window.location.pathname + window.location.search;
    if (this.isValidReturnUrl(path)) {
      return path;
    }
    return null;
  }

  redirectToLogin(returnUrl?: string): void {
    const url = returnUrl || this.getCurrentAppUrl();
    if (url && this.isValidReturnUrl(url)) {
      sessionStorage.setItem(this.POST_LOGIN_RETURN_URL_KEY, url);
      this.router.navigate(['/login'], { queryParams: { returnUrl: url } });
    } else {
      this.router.navigate(['/login']);
    }
  }

  private getReturnUrl(): string | null {
    const queryReturnUrl = this.router.parseUrl(this.router.url).queryParams['returnUrl'];
    if (queryReturnUrl && this.isValidReturnUrl(queryReturnUrl)) {
      return queryReturnUrl;
    }
    const storedReturnUrl = sessionStorage.getItem(this.POST_LOGIN_RETURN_URL_KEY);
    if (storedReturnUrl && this.isValidReturnUrl(storedReturnUrl)) {
      return storedReturnUrl;
    }
    return null;
  }

  private clearStoredReturnUrl(): void {
    sessionStorage.removeItem(this.POST_LOGIN_RETURN_URL_KEY);
  }

  private navigateAfterLogin(): void {
    const returnUrl = this.getReturnUrl();

    if (this._activated && this._activated.snapshot && this._activated.snapshot.queryParamMap && this._activated.snapshot.queryParamMap.get('sp_id')) {
      let params = this._activated.snapshot.queryParamMap.get('sp_id');
      this.router.navigate(['/app/pricing'], { queryParams: { sp_id: params } });
    } else if (this._activated && this._activated.snapshot && this._activated.snapshot.queryParamMap && this._activated.snapshot.queryParamMap.get('type')) {
      let type = this._activated.snapshot.queryParamMap.get('type');
      let id = this._activated.snapshot.queryParamMap.get('id');
      this.router.navigate(['/app/profile'], { queryParams: { id: id, type: type } });
    } else if (returnUrl) {
      this.clearStoredReturnUrl();
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigate(['app', 'finance-customer']);
    }
  }

  login(formData: any): Observable<any> {
    let data = formData;
    return this.http.post<any>(environment.baseUrl + 'email_login', data, { headers: this.headers })
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => { return throwError(error) })
      );
  }

  accessTokenLogin() {
    let data = {
      device_type: environment.device_type,
      app_type: environment.app_type,
      app_version: environment.app_version,
      device_token: environment.device_token,
      device_id: localStorage.getItem('user'),
      access_token: localStorage.getItem('token'),
      environment: environment.env
    };

    this.http.post<any>(environment.baseUrl + 'access_token_login', data, { headers: this.headers })
      .subscribe((response: any) => {
        this.getUsersubscription();
        if (response.flag === 116) {
          localStorage.setItem('reset_password_token', response.reset_password_token);
          this.router.navigate(['new-password']);
        } else {
          if (response.profile) {
            setUserProfiles(response.profile);
            this.userProfileData$.next(response.profile);
            sessionStorage.removeItem('defaultDoctorApplied');
            if(response.profile[0].role_id == 1) {
              let selectedLocation = localStorage.getItem('globalFilter');
              if(!selectedLocation) {
                this.globalService.setGlobalFilter({type: 'location',name: 'All'})
              }
            }
            this.role_id = response.profile[0].role_id;
            this.checkTermsConditions(response.profile);
          } else if (response.doctor_profile) {
            setUserProfiles(response.doctor_profile);
            this.userProfileData$.next(response.doctor_profile);
            this.role_id = response.doctor_profile[0].role_id;
          }
          // Social platform master list — the rewards listing seeds its platform rows from it.
          if (response && response.social_platforms_data) {
            localStorage.setItem(STORAGE_KEYS.SOCIAL_PLATFORMS_DATA, JSON.stringify(response.social_platforms_data));
          }
          if (response) {
            const terminalCount = +(response.terminalsql ?? response.total_terminals ?? 0) || 0;
            localStorage.setItem(STORAGE_KEYS.TOTAL_TERMINALS, String(terminalCount));
            this.total_terminals$.next(terminalCount);
            // Delivered-terminal flag. ReviewPromptService reads it before claiming the review tab.
            localStorage.setItem(STORAGE_KEYS.REVIEW_FLOW, String(+(response.review_flow ?? 0) || 0));
            // Lets process payment skip Customer Information; the payment page reads it on init.
            const skipCustomerInfo = +(response?.doctor_settings?.skip_customer_info ?? 0) === 1;
            localStorage.setItem(STORAGE_KEYS.SKIP_CUSTOMER_INFO, skipCustomerInfo ? '1' : '0');
            // Caps the amount the skip is offered for; anything missing or not above 0 means no limit.
            const ppSkipMaxAmount = Number(response?.doctor_settings?.pp_skip_max_amount);
            localStorage.setItem(STORAGE_KEYS.PP_SKIP_MAX_AMOUNT, String(ppSkipMaxAmount > 0 ? ppSkipMaxAmount : 0));
          }
          if (response.plan_info && response.plan_info.length) {
            this.plan_info$.next(response.plan_info[0]);
            this.authPlanInfo = response.plan_info[0];
          }
          if (response.subscription_billing_page) {
            this.subscription_billing_page$.next(response.subscription_billing_page);
          }
          if (response && response.doctor_settings) {
            this.is_allowed = !response.profile[0].show_subscription ? !response.profile[0].show_subscription : this.subscription_global_setting(6);
            if (this.is_allowed) this.openChatBot();
            this.doctorDefaultVales$.next(response.doctor_settings);
            setDoctorSettings(response.doctor_settings);
            // localStorage.setItem('doctorSettings', JSON.stringify(response.doctor_settings));
            PrepaidCardService.cacheSettings(response.doctor_settings);
          } else if(response.profile && response.profile[0].role_id == 1) {
            this.openChatBot();
          }

          let maintenance: any =  {
            maintenance_dashboard_mode: response.maintenance_dashboard_mode,
            maintenance_dashboard_mode_text1: response.maintenance_dashboard_mode_text1,
            maintenance_dashboard_mode_text2: response.maintenance_dashboard_mode_text2,
            maintenance_dashboard_mode_text3: response.maintenance_dashboard_mode_text3,
          }
          this.maintenanceData.next(maintenance);
          if(!window.location.href.includes('/verification?')){
            this.getNotifications();
          }

          if(this.showNextKYB) {
            // this.showNextKYB = 0;
            this.showPersona.next(1);
          }

          if (response && response.lendee_offer_status && response.lendee_offer_status.total_offers && response.lendee_offer_status.total_offers > 0) {
            const currentUrl = this.router.url;
            if (currentUrl == '/app/dashboard' || currentUrl == '/app/finance-customer') {
              this.showLendeeOffer(response.lendee_offer_status);
            }
          }
          localStorage.setItem('lendee_offer_status', JSON.stringify(response.lendee_offer_status || {}));
        }
      })
  }

  getNotifications() {
    let params = {
      access_token: localStorage.getItem('token'),
      limit: 10,
      offset: 0,
      type: ''
    };

    this.http.post<any>(environment.baseUrl + 'fetch_business_notifications', params, { headers: this.headers })
    .subscribe((data: any) => {
      if (data && data.is_error == 0) {
        this.unread_count.next(data.unread_count);
      }
    });
  }

  getbankDetails() {
    let banKapiData = {
      device_type: environment.device_type,
      app_type: environment.app_type,
      app_version: environment.app_version,
      device_token: environment.device_token,
      device_id: localStorage.getItem('user'),
      access_token: localStorage.getItem('token'),
      environment: environment.env,
    };

    this.http.post<any>(environment.baseUrl + 'get_profile', banKapiData, { headers: this.headers })
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.getProfileData = data;
          this.getProfileData$.next(data);
          setUserProfiles([{ ...getUserProfile(), ...data.profile[0] }]);
          this.userProfileData$.next([{ ...getUserProfile(), ...data.profile[0] }])
          return data;
        }
      });
  }


  setLoginData(data) {
    if (!localStorage.getItem('timezone')) {
      localStorage.setItem('timezoneName', 'PST');
      localStorage.setItem('timezone', '-0700');
    }
    if (data && data.token) {
      localStorage.setItem('token', data.token);
    }
    if (data.profile) {
      setUserProfiles(data.profile);
      this.userProfileData$.next(data.profile);
      this.checkTermsConditions(data.profile);
    }

    if (data.profile[0].role_id) {
      setStoredRoleId(data.profile[0].role_id);
      this.roleId$.next(data.profile[0].role_id);
    }
    if (data.doctor_profile) {
      setUserProfiles(data.doctor_profile);
      this.userProfileData$.next(data.doctor_profile);
    }
    if (data.plan_info && data.plan_info.length) {
      this.plan_info$.next(data.plan_info[0]);
      this.authPlanInfo = data.plan_info[0];
    }
    if (data.subscription_billing_page) {
      this.subscription_billing_page$.next(data.subscription_billing_page);
    }
    if (data.fixed_flat_fee) {
      localStorage.setItem('fixed_flat_fee', JSON.stringify(data.fixed_flat_fee));
    }
    if (data.recurring_extra_amount) {
      localStorage.setItem('recurring_extra_amount', JSON.stringify(data.recurring_extra_amount));
    }
    if (data.menu && data.menu.length > 0 && data.menu.filter(menu => menu.path.includes('dashboard')).length == 0) {
      const returnUrl = this.getReturnUrl();
      if (returnUrl) {
        this.clearStoredReturnUrl();
        this.router.navigateByUrl(returnUrl);
      } else {
        this.router.navigate(['app/finance-customer']);
      }
    } else {
      this.navigateAfterLogin();
    }
    if (this.is_allowed) {
      this.openChatBot();
    }

    this._socket.connectToBackend();
  }

  dialog_opened = 0;
  checkTermsConditions(profile_data) {
    if (profile_data && profile_data[0] && profile_data[0].role_id == 4 && profile_data[0].terms_seen == 0 && this.dialog_opened == 0) {
      this.dialog_opened = 1;
      let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
        width: '950px',
        disableClose: true,
        panelClass: 'simpleDialog',
        data: {
          type: (profile_data[0].ind_id == 1 || profile_data[0].ind_id == 6) ? 47 : 46
        }
      });
      confirmDialogRef.afterClosed().subscribe(result => {
        this.dialog_opened = 0;
      });
    }
  }
  openChatBot() {
    let user_info = getUserProfiles();
    if (user_info && user_info[0]) {
      var firstName = user_info[0].enterprise_first_name ? user_info[0].enterprise_first_name : (user_info[0].agent_id ? user_info[0].agent_name : user_info[0].doctor_first_name);
      var lastName = user_info[0].enterprise_last_name ? user_info[0].enterprise_last_name : (user_info[0].agent_id ? "" : user_info[0].doctor_last_name);
      var userphonenumber = user_info[0].enterprise_mobile ? user_info[0].enterprise_mobile : (user_info[0].agent_id ? user_info[0].agent_mobile : user_info[0].doctor_mobile);
      var useremail = user_info[0].enterprise_email ? user_info[0].enterprise_email : (user_info[0].agent_id ? user_info[0].agent_email : user_info[0].doctor_email);
      // this.intercom.boot({
      //   app_id: "lur7iuqc",
      //   job_title: 'Business Panel',
      //   custom_launcher_selector: '#open_chat',
      //   hide_default_launcher: true
      // });
      // setTimeout(() => {
      //   this.intercom.update({
      //     user_id: useremail,
      //     name: firstName + ' ' + lastName,
      //     email: useremail,
      //     phone: userphonenumber ? userphonenumber.split('+1-')[1] : null,
      //     job_title: 'Business Panel',
      //     custom_launcher_selector: '#open_chat',
      //     hide_default_launcher: true
      //   })
      //   this.showIntercomIcon = true;
      // }, 600);
      Intercom('boot', {
        app_id: 'lur7iuqc',
        user_id: useremail,
        name: `${firstName} ${lastName}`,
        email: useremail,
        phone: userphonenumber ? userphonenumber.split('+1-')[1] : null,
        job_title: 'Business Panel',
        custom_launcher_selector: '#open_chat',
        hide_default_launcher: true
      });
      this.showIntercomIcon = true;
    }
  }
  getUsersubscription() {
    let subsData = {
      access_token: localStorage.getItem('token')
    };

    if(localStorage.getItem("roleId") == "1") {
      let locationDetails = this.globalService.getFilterObj('location');
      if(locationDetails &&  locationDetails.id) {
        subsData['doctor_id'] = locationDetails.id;
      }
    }

    this.http.post<any>(environment.baseUrl + 'subscription_detail', subsData, { headers: this.headers })
      .subscribe((data: any) => {
        if (data.response) {
          localStorage.setItem("subscription_data", JSON.stringify(data.response))
          return data;
        }
      });
  }

  subscription_global_setting(f_id){
    this.subscription_data = localStorage.getItem('subscription_data') ? JSON.parse(localStorage.getItem('subscription_data')): null;
    if(this.subscription_data){
      for (const [key, value] of Object.entries(this.subscription_data.plan_feature)) {
        if(value['f_id']==f_id){
          if(value['is_allowed']==1){
            return true
          }else{
            return false
          }
        }
      }
    }
  }

  showLendeeOffer(data) {
    if (this.isDialogOpen) return;
    this.isDialogOpen = true;
    let queryParams = {pfStatus: 10};
    if (data && data.total_offers && data.total_offers == 1) {
        queryParams['contract_id'] = data.offers[0].contract_id;
    }
    let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '500px',
      disableClose: true,
      panelClass: 'simpleDialog',
      data: {
        type: 943,
        loan_amount: data.offers.reduce((sum, item) => sum + item.early_payout_amount, 0),
        total: data.total_offers,
        queryParam: queryParams
      }
    });
    confirmDialogRef.afterClosed().subscribe(result => {
      this.isDialogOpen = false;
    });
  }
}
